<template>
  <div id="productadv-css">
    <!-- 面包屑 -->
    <base-bread style="margin-left: 5vh;">
      <base-bread-item to="/">首页</base-bread-item>
      <base-bread-item>解决方案</base-bread-item>
    </base-bread>
    <div id="product-adv-top">
      <h1>行业解决方案</h1>
      <p>全心服务  智慧物流</p>
    </div>
    <el-divider/>
    <ProductadvSolveDescribe/>
  </div>
</template>

<script setup>
import { findAd } from '/composables/api/home';

const dataSource = ref([]);
const dataSource2 = ref([]);

onMounted(async () => {
  try {
    const data1 = await findAd("htmlSolveImage");
    dataSource.value = data1.data.list[0];

    const data2 = await findAd("htmlCaseImage");
    dataSource2.value = data2.data.list[0];
  } catch (error) {
    console.error('获取广告数据失败:', error);
  }
});
</script>

<style scoped lang="less">
#productadv-css {
  background-color: #FFF;

  #product-adv-top {
    padding-left: 10vh;
    padding-bottom: 5vh;

    h1 {
      font-size: 40px;
      padding-bottom: 10px;
    }

    p {
      font-size: 20px;
      font-weight: 600;

    }
  }
}


//.text-split-line {
//  background: #fff;
//  display: flex;
//  align-items: center;
//  text-align: center;
//  height: 160px;
//  padding: 0 80px;
//
//  .info {
//    padding-left: 10px;
//    flex: 1;
//
//    p {
//      &:first-child {
//        font-size: 32px;
//        font-weight: bold;
//        margin-bottom: 18px;
//      }
//
//      &:last-child {
//        color: #999;
//        font-size: 16px;
//      }
//    }
//  }
//}
</style>
